(function () {
  'use strict';
  if (window.AEEN) return;
  var timer;
  function notify(message, error) {
    var status = document.getElementById('aeen-status');
    if (!status) {
      status = document.createElement('div');
      status.id = 'aeen-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      document.body.appendChild(status);
    }
    clearTimeout(timer);
    status.textContent = message;
    status.classList.toggle('is-error', !!error);
    status.hidden = false;
    timer = setTimeout(function () { status.hidden = true; }, error ? 7000 : 4000);
  }
  function discountApplied(cart, code) {
    var normalized = code.trim().toLowerCase();
    if (Array.isArray(cart.discount_codes)) {
      var match = cart.discount_codes.find(function (entry) {
        return String(entry.code).toLowerCase() === normalized;
      });
      if (match) return match.applicable === true;
    }
    var applications = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || item.discount_allocations || []).forEach(function (allocation) {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });
    return applications.some(function (application) {
      return application.type === 'discount_code' && String(application.title).toLowerCase() === normalized;
    });
  }
  function updateHeader(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: cart.currency || 'PKR',
      minimumFractionDigits: cart.currency === 'PKR' ? 0 : 2,
      maximumFractionDigits: cart.currency === 'PKR' ? 0 : 2
    }).format(Number(cart.total_price) / 100).replace('PKR','Rs.');
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && typeof t_moneyFormat !== 'undefined') {
      formatted = Shopify.formatMoney(cart.total_price, t_moneyFormat);
    }
    document.querySelectorAll('.icon_cart .js_cat_ttprice, #ntheader .js_cat_ttprice').forEach(function (el) {
      el.innerHTML = formatted;
    });
    document.querySelectorAll('.jsccount, .cart_count, .nt_cart_count, [data-cart-count]').forEach(function (el) {
      if(el.id === 'AEENCartPage') { el.setAttribute('data-cart-count',cart.item_count); return; }
      el.textContent = cart.item_count;
    });
  }
  window.AEEN = { notify: notify, discountApplied: discountApplied, updateHeader: updateHeader };
  document.addEventListener('aeen:cart:updated', function (event) { updateHeader(event.detail && event.detail.cart); });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && window.AEENCartDrawer) AEENCartDrawer.refresh({silent:true}).catch(function () {
      notify('Could not refresh your bag. Please try again.', true);
    });
  });
})();
